module.exports = __webpack_public_path__ + "static/media/portfoli_banner2_img.2a45a8d3.png";